export let uSDXGlobalObject: any = {
    stTime: 0,
    updateTime: function (newTime: number) {
        this.stTime = newTime;
    }
};
